"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackEecProductDetail = void 0;
const enums_1 = require("../enums");
const buildEecProduct_1 = require("./buildEecProduct");
const buildGA4ProductDetail_1 = require("./buildGA4ProductDetail");
const clearGA4EventData_1 = require("./clearGA4EventData");
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackEecProductDetail(product, variant, isLocationSelected) {
    (0, clearGA4EventData_1.clearGA4EventData)();
    const ga4EventData = (0, buildGA4ProductDetail_1.buildGA4ProductDetailInteraction)({
        eventName: enums_1.GA4EventName.ViewItem,
        featureCategory: enums_1.GA4FeatureCategory.Ecommerce,
        product,
        variant,
        isLocationSelected,
    });
    const eecData = {
        event: enums_1.EventName.EECProductDetail,
        ecommerce: {
            detail: {
                products: [(0, buildEecProduct_1.buildEecProduct)({ product, variant })],
            },
        },
        ...(ga4EventData && {
            eventData: ga4EventData.eventData,
        }),
    };
    (0, pushToDataLayer_1.pushToDataLayer)(eecData);
}
exports.trackEecProductDetail = trackEecProductDetail;
//# sourceMappingURL=trackEecProductDetail.js.map